
<template >
  <div>
    <div
      class="
        d-flex
        justify-content-end
        align-items-center
        content-sidebar-header
        px-2
        py-1
      "
    >
    <b-card-code title="Backup Codes" >
<p>
    Save these codes so that you can use one of these codes in case if you lost your 2FA device.
</p>
    <li v-for="code in codes" :key="code">{{code}}</li>
    </b-card-code>
    </div>
    </div>
</template>
<script>
import BCardCode from "@core/components/b-card-code/BCardCode.vue";
export default {
  components: {
    BCardCode,
  },
  props: {
    codes: {
      type: Array,
      required: true,
    },
    closeSidebar: {
      type: Function,
      required: true,
    },
  },
};
</script>
